<template>
  <div
    ref="$el"
    :class="cmpClass"
  />
</template>
<script setup lang="ts">
  import {
    ref, reactive, computed, watchEffect, withDefaults,
  } from 'vue'
  import { Direction } from '../../enums'

  const props = withDefaults(
    defineProps<{
      /**
       * 设置 divider 方向
       */
      direction?: Direction
      dashed?: boolean
    }>(),
    {
      direction: 'horizontal',
      dashed: false,
    },
  )

  const cmpClass = computed(
    () => [
      'd-divider',
      `d-divider-${props.direction}`,
      props.dashed && 'd-divider-dashed',
    ],
  )

  const $el = ref<HTMLElement>()

  const exposed = reactive({
    $el: $el.value,
  })

  watchEffect(
    () => {
      exposed.$el = $el.value
    },
  )

  defineExpose(exposed)
</script>
